import { ownerFacingGlobalError } from "../ownerFacingGlobalError";

export type DashboardStatusErrorSurface =
  | "agent-registry"
  | "agent-teams"
  | "approval-inbox"
  | "worker-runner"
  | "worker-status"
  | "control-center";

const SURFACE_LABELS: Record<DashboardStatusErrorSurface, string> = {
  "agent-registry": "Agent-Registry",
  "agent-teams": "Agent-Team",
  "approval-inbox": "Approval-Inbox",
  "worker-runner": "Worker-Runner",
  "worker-status": "Worker",
  "control-center": "Control-Center",
};

function dashboardStatusErrorText(error: unknown): string {
  return error instanceof Error ? error.message : String(error);
}

export function dashboardStatusErrorCopy(
  error: unknown,
  surface: DashboardStatusErrorSurface,
): string {
  const text = dashboardStatusErrorText(error);
  if (
    /agent.*not found|registry.*not found|team.*not found|approval.*not found|inbox.*not found|worker.*not found|runner.*not found|control.*not found|dashboard_state|snapshot.*stale|stale.*dashboard|status.*not found|state_invalid/i.test(
      text,
    )
  ) {
    return `${SURFACE_LABELS[surface]}-Status ist nicht mehr aktuell. Bitte Dashboard-Live-Daten neu laden.`;
  }
  return ownerFacingGlobalError(text);
}
